module.exports = __webpack_public_path__ + "static/media/Thumbs.3ea190b7.db";